import * as Handlebars from 'handlebars/runtime'
module.exports = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "	<div class=\"label-with-icon is-comma-separated-when-grouped\">\n		<span class=\"icon-container avatar default-avatar\">"
    + ((stack1 = (lookupProperty(helpers,"icon")||(depth0 && lookupProperty(depth0,"icon"))||container.hooks.helperMissing).call(alias1,"user-avatar",{"name":"icon","hash":{},"data":data,"loc":{"start":{"line":3,"column":53},"end":{"line":3,"column":77}}})) != null ? stack1 : "")
    + "</span>\n		<div>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"groupType") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":21},"end":{"line":4,"column":108}}})) != null ? stack1 : "")
    + "</div>\n	</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"post-label group-type\">("
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"groupTypeLabel") || (depth0 != null ? lookupProperty(depth0,"groupTypeLabel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"groupTypeLabel","hash":{},"data":data,"loc":{"start":{"line":4,"column":75},"end":{"line":4,"column":93}}}) : helper)))
    + ")</span>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"value") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":6,"column":9}}})) != null ? stack1 : "");
},"useData":true})